/* eslint-disable react/jsx-no-target-blank */
import { useAuth } from '../../../../app/modules/auth';
import { KTIcon } from '../../../helpers'

const SidebarFooter = () => {
  const { logout } = useAuth();
  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <a
        href="#"
        onClick={logout}
        className='btn btn-flex gap-2 flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
      >
        <KTIcon iconName='technology-3' className='fs-2 m-0' />
        <span className='btn-label'>Log Out</span>
      </a>
    </div>
  )
}

export { SidebarFooter }
